import { Country, Language, Currency } from "@/apis/address/address.interface"

export enum PAGE_TYPE {
  PERSON = 'person',
  SHIPPING = 'shipping',
  BILLING = 'billing',
  PAY_BILLING = 'pay_billing', // 收银台（信用卡支付）
  ADDRESS_LIB = 'address_lib', // 地址组件
}

export enum PICK_MODIFY_TYPE {
  SAVE = 1, // 收藏
  UN_SAVE = 2, // 取消收藏
  DEFAULT = 3, // 设置默认
  UD_DEFAULT = 4 // 取消设置默认
}

export enum ADDRESS_VERIFY_TYPE {
  NO_VERIFY = 0, // 不校验
  COUNTRY_VERIFY = 1, // 按国家维度校验
  SITE_VERIFY = 2 // 按站点维度校验
} 

/**
 * 各国家默认地址配置
 */
export const DEFAULT_COUNTRY_ADDRESSES: Record<string, {
  provinceId: number;
  cityId: number;
  districtId: number;
  townId: number;
  postCode: string;
}> = {
  // 英国
  'GB': {
    provinceId: 30000004,
    cityId: 30000005,
    districtId: 30000006,
    townId: 30000007,
    postCode: 'SW1A 1AA',
  },
  // 荷兰
  'NL': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 比利时
  'BE': {
    provinceId: 132326,
    cityId: 400600,
    districtId: 400601,
    townId: 0,
    postCode: '1000',
  },
  // 卢森堡
  'LU': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 法国
  'FR': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 德国
  'DE': {
    provinceId: 58594,
    cityId: 397323,
    districtId: 0,
    townId: 0,
    postCode: '10117',
  },
  // 爱尔兰
  'IE': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 爱沙尼亚
  'EE': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 奥地利
  'AT': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 保加利亚
  'BG': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 波兰
  'PL': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 丹麦
  'DK': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 芬兰
  'FI': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 捷克
  'CZ': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 克罗地亚
  'HR': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 拉脱维亚
  'LV': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 立陶宛
  'LT': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 罗马尼亚
  'RO': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 葡萄牙
  'PT': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 瑞典
  'SE': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 瑞士
  'CH': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 斯洛文尼亚
  'SI': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 西班牙
  'ES': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 希腊
  'GR': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 匈牙利
  'HU': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
  // 意大利
  'IT': {
    provinceId: 0,
    cityId: 0,
    districtId: 0,
    townId: 0,
    postCode: '',
  },
};
